import { combineEpics } from "redux-observable";
import { navigationEpics } from "./navigation";
import { publicBadgeEpics } from "./publicBadge";
import { badgesEpics } from "./badges";
import { loginEpics } from "./login";
import { sessionEpics } from "./session";
import { navigateGlobalEpic } from "./navigation/navigationEpics";

const rootEpic = combineEpics(
  navigationEpics.navigateGlobalEpic,
  navigationEpics.navigateEpic,
  publicBadgeEpics.getBadgeDataEpic,
  badgesEpics.getBadgesTableDataEpic,
  badgesEpics.deleteBadgeEpic,
  badgesEpics.createBadgesEpic,
  loginEpics.submitLoginEpic,
  loginEpics.loginSuccessEpic,
  loginEpics.signupSuccessEpic,
  sessionEpics.deleteSessionEpic,
  sessionEpics.setSessionEpic,
  sessionEpics.loadDataEpic,
  sessionEpics.readSessionEpic
);

export default rootEpic;
